import { useRoute } from 'vue-router';

import { DrawerService } from '@/core/shared/drawer/drawer.service';
import MeService from '@/core/shared/me/me.service';
import TrackingService from '@/core/shared/tracking/tracking.service';
import { TrackingActionName } from '@/core/shared/tracking/tracking-actions';
import {
  type HelpContext,
  helpCenterUrl,
  helpContextFor,
} from '@/core/shared/help-center/help-center-url';

/**
 * Help for wherever the user is. The left nav's ? button opens it in the help drawer; on
 * phones, where there's no left nav, the menu's Get help view links to it in a new tab.
 */
export function useHelpButton(): {
  onHelpClick: () => void;
  onHelpLinkClick: () => void;
  helpContext: () => HelpContext | null;
  helpPageUrl: () => string;
} {
  const route = useRoute();
  const meService = new MeService();
  const drawerService = new DrawerService();

  const helpContext = (): HelpContext | null =>
    helpContextFor(route, meService.userProfile?.createTs);

  const helpPageUrl = (): string => helpCenterUrl(helpContext());

  const track = (mode: 'drawer' | 'new-tab'): void => {
    TrackingService.trackAction(TrackingActionName.HELP_CENTER_OPENED, {
      context: helpContext() ?? 'home',
      route: route.name,
      mode,
    });
  };

  const onHelpClick = (): void => {
    track('drawer');
    drawerService.isHelpDrawerOpen = true;
  };

  const onHelpLinkClick = (): void => track('new-tab');

  return { onHelpClick, onHelpLinkClick, helpContext, helpPageUrl };
}
